import { render, staticRenderFns } from "./ManagePage.vue?vue&type=template&id=6d52046c&"
import script from "./ManagePage.vue?vue&type=script&lang=js&"
export * from "./ManagePage.vue?vue&type=script&lang=js&"
import style0 from "../../../assets/scss/Notification.scss?vue&type=style&index=0&lang=scss&"
import style1 from "../assets/scss/Manage.scss?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports